import CONSTANTS from 'src/utils/constants';
import { DerivedAllocationSheetData } from 'src/models/derived-allocation-sheet/DerivedAllocationSheet';

export const SUBMIT_UNSAVED_REASON = 'Save your changes before submitting the sheet for review.';
export const SUBMIT_NOT_EXECUTED_REASON = 'Execute the sheet, check its output, then submit it for review.';
export const SUBMIT_STALE_REASON = 'The sheet changed after its last execution. Execute it again, then submit it for review.';
export const DOWNLOAD_NOT_EXECUTED_REASON = 'Execute the sheet to download its output.';
export const DOWNLOAD_NO_OUTPUT_REASON = 'This version has no output to download.';

/**
 * Why a draft cannot be submitted for review yet, following the backend's Submit checks: the draft must be saved,
 * executed with an output, and its last execution must have started after its last content change.
 * @param sheet The draft.
 * @param hasUnsavedWork Whether a step has changes that are not saved yet.
 * @returns The reason, or undefined when the draft can be submitted.
 */
export function submitBlockedReason(sheet: DerivedAllocationSheetData, hasUnsavedWork: boolean): string | undefined {
    if (hasUnsavedWork) return SUBMIT_UNSAVED_REASON;
    if (!sheet.lastExecutionTimestamp || !sheet.draftOutputS3Url) return SUBMIT_NOT_EXECUTED_REASON;
    if (sheet.contentModifiedDate != null && sheet.lastExecutionTimestamp <= sheet.contentModifiedDate) return SUBMIT_STALE_REASON;
    return undefined;
}

/**
 * Why the open version has nothing to download: the draft has its own output, written by Execute, and every
 * other version has the output that went live with it.
 * @returns The reason, or undefined when the version has an output.
 */
export function downloadBlockedReason(sheet: DerivedAllocationSheetData): string | undefined {
    if (sheet.sheetVersion === CONSTANTS.CALCULATION_VERSIONS.DRAFT_VERSION) {
        return sheet.draftOutputS3Url ? undefined : DOWNLOAD_NOT_EXECUTED_REASON;
    }
    return sheet.outputS3Url ? undefined : DOWNLOAD_NO_OUTPUT_REASON;
}
